import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ExplorePage from "../pages/explore/page";
import CampaignPage from "../pages/campaign/page";
import ImpactReportPage from "../pages/campaign/components/ImpactReportPage";
import ProfilePage from "../pages/profile/page";
import CreateCampaignPage from "../pages/create/page";
import DashboardPage from "../pages/dashboard/page";
import NotificationsPage from "../pages/notifications/page";
import SettingsPage from "../pages/settings/page";
import AboutPage from "../pages/about/page";
import AuthPage from "../pages/auth/page";
import ContactPage from "../pages/contact/page";
import Layout from "../components/feature/Layout";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/explore", element: <ExplorePage /> },
      { path: "/campaign/:id", element: <CampaignPage /> },
      { path: "/campaign/:id/report", element: <ImpactReportPage /> },
      { path: "/profile/:username", element: <ProfilePage /> },
      { path: "/create", element: <CreateCampaignPage /> },
      { path: "/dashboard", element: <DashboardPage /> },
      { path: "/notifications", element: <NotificationsPage /> },
      { path: "/settings", element: <SettingsPage /> },
      { path: "/about", element: <AboutPage /> },
      { path: "/contact", element: <ContactPage /> },
      { path: "/login", element: <AuthPage /> },
      { path: "/register", element: <AuthPage /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
